/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'querybuilder': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M97.582 75H76.75c-1 0-1.75.668-1.75 1.75v20.832c0 1 .668 1.75 1.75 1.75h20.832c1 0 1.75-.668 1.75-1.75V76.75c0-1.082-.75-1.75-1.75-1.75zM52.418 64.582h45.168c1 0 1.75-.668 1.75-1.75l-.004-10.414c0-1.082-.668-1.75-1.75-1.75H52.418c-1 0-1.75.668-1.75 1.75v10.418c0 1.082.75 1.746 1.75 1.746zM52.418 99.332h10.418c1 0 1.75-.668 1.75-1.75V76.75c0-1.082-.668-1.75-1.75-1.75H52.418c-1 0-1.75.668-1.75 1.75v20.832c0 1 .75 1.75 1.75 1.75z"/><path pid="1" d="M113.168 33.332H36.832a3.52 3.52 0 0 0-3.5 3.5v76.418a3.52 3.52 0 0 0 3.5 3.5h76.418a3.52 3.52 0 0 0 3.5-3.5V36.832c-.082-1.914-1.668-3.5-3.582-3.5zm-3.418 76.418h-69.5v-69.5h69.418v69.5h.082z"/></g>'
  }
})
